export const defaultTablePageSize = 20;
